import { action, computed, makeAutoObservable, observable } from 'mobx';
import { User } from 'types/user';

class UserStore {
  @observable private _user: User | null = null;

  constructor() {
    makeAutoObservable(this)
  }

  @computed
  public get user(): User | null {
    return this._user;
  }

  @action
  public setUser = (user: User) => {
    this._user = user;
  };

  @action
  public clearUser = () => {
    this._user = null;
  };
}

export default new UserStore();
